// extracted by mini-css-extract-plugin
export default {"SKUSelector--container":"SKUSizeSelector_SKUSelector--container__-JUuQ"};